(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wordfor"] && !Shopify.designMode) return;
  try {
    

if ( $('.product__slider-main').length ) {
        var $slider = $('.product__slider-main')
            .on('init', function(slick) {
                $('.product__slider-main').fadeIn(1000);
            })
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
  lazyLoad: 'ondemand',
                autoplaySpeed: 6000,
                asNavFor: '.product__slider-thmb'
            });

    var $slider2 = $('.product__slider-thmb')
            .on('init', function(slick) {
                $('.product__slider-thmb').fadeIn(1000);
            })
            .slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                asNavFor: '.product__slider-main',
                dots: false,
              autoplay: true,
               autoplaySpeed: 6000,
                arrows: true,
                centerMode: false,
               prevArrow: '<div class="class-to-style prev"><svg width="30px" height="30px" enable-background="new 0 0 32 32"  id="Слой_1" version="1.1" viewBox="0 0 32 32"  xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path clip-rule="evenodd" d="M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z" fill="#121313" fill-rule="evenodd" id="Chevron_Right"/><g/><g/><g/><g/><g/><g/></svg><span class="sr-only">Prev</span></div>',
nextArrow: '<div class="class-to-style next"><svg width="30px" height="30px" enable-background="new 0 0 32 32"  id="Слой_1" version="1.1" viewBox="0 0 32 32"  xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path clip-rule="evenodd" d="M21.698,15.286l-9.002-8.999  c-0.395-0.394-1.035-0.394-1.431,0c-0.395,0.394-0.395,1.034,0,1.428L19.553,16l-8.287,8.285c-0.395,0.394-0.395,1.034,0,1.429  c0.395,0.394,1.036,0.394,1.431,0l9.002-8.999C22.088,16.325,22.088,15.675,21.698,15.286z" fill="#121313" fill-rule="evenodd" id="Chevron_Right"/><g/><g/><g/><g/><g/><g/></svg></i><span class="sr-only">Next</span></div>', 
                focusOnSelect: true,
                responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    },
     {
      breakpoint: 569,
      settings: {
        slidesToShow:1
      }
    },
  ]
            });

 //remove active class from all thumbnail slides
 $('.product__slider-thmb .slick-slide').removeClass('slick-active');

 //set active class to first thumbnail slides
 $('.product__slider-thmb .slick-slide').eq(0).addClass('slick-active');

 // On before slide change match active thumbnail to current slide
 $('.product__slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
 	var mySlideNumber = nextSlide;
 	$('.product__slider-thmb .slick-slide').removeClass('slick-active');
 	$('.product__slider-thmb .slick-slide').eq(mySlideNumber).addClass('slick-active');
});
  
  
  // init slider
require(['js-sliderWithProgressbar'], function(slider) {

    $('.product__slider-main').each(function() {

        me.slider = new slider($(this), options, sliderOptions, previewSliderOptions);

        // stop slider
        //me.slider.stop();

        // start slider
        //me.slider.start(index);

        // get reference to slick slider
        //me.slider.getSlick();

    });
});
  var options = {
    progressbarSelector    : '.bJS_progressbar'
    , slideSelector        : '.bJS_slider'
    , previewSlideSelector : '.bJS_previewSlider'
    , progressInterval     : ''
        // add your own progressbar animation function to sync it i.e. with a video
        // function will be called if the current preview slider item (".b_previewItem") has the data-customprogressbar="true" property set
    , onCustomProgressbar : function($slide, $progressbar) {}
}

    // slick slider options
    // see: https://kenwheeler.github.io/slick/
var sliderOptions = {
    slidesToShow   : 1,
    slidesToScroll : 1,
    arrows         : false,
    fade           : true,
    autoplay       : true
}

    // slick slider options
    // see: https://kenwheeler.github.io/slick/
var previewSliderOptions = {
    slidesToShow   : 3,
    slidesToScroll : 1,
    dots           : false,
    focusOnSelect  : true,
    centerMode     : true
}
}
  

  } catch(e) { console.error(e); }
})();
})();
